import React, { Component, Fragment } from 'react';
import { Direction } from '../constants';
import { createActivity } from '../utils/leadUtils';
import {
  roundOffToStep,
  getSuggestedAmountSafely,
  parseFundRating,
  randomNumber,
} from '../utils/commonUtils';
import { trackAction, trackPixel } from '../utils/trackActions';
import {
  getSubHeading,
  handleBackNavigation,
  disableBackButton,
  handleBackAction,
} from '../utils/paymentModalUtils';
import { redirectToLoginPage, showError } from '../utils';
import { Api } from '../api';
// @ts-ignore
import { Router } from '../configs/routes';
import Modal from '../components/modal';
import { parse, stringify } from 'query-string';
// import ReactMarkdown from 'react-markdown';
// import Error from '../components/Error404';
import InvestFlowView from '../components/invest/investFlowView';
import PennyDropView from '../components/common/pennyDropView';
import { optimizeFundData } from '../components/singleFund/singleFundConst';
import get from 'lodash.get';
import { getComponentTree } from '../utils/componentTree';
import MandateFlowView from '../components/mandate/mandateFlowView';
import Header from '../components/nextHead';
import { presentYear } from '../constants/getPresentYear';
import {
  getIsLoggedInCookie,
  getUserInfoSessionData,
} from '../utils/sessionUtil';
import OtpModal from '../components/dashboard/otpModal';
import KycUnderReviewModal from '../components/kyc/KycUnderReviewModal';
import KycIncompleteModal from '../components/kyc/KycIncompleteModal';

const api = new Api();
interface Props {
  selectedFund: any;
  url: any;
  fundData: any;
  statusCode: number;
  userInfo: any;
  entity: any;
  hasUserInvestedInProduct: boolean;
  pendingActions: any;
  pageData: any;
}

interface State {
  investmentType: Direction;
  amount: number;
  minAmount: number;
  maxAmount: number;
  startFlow: boolean;
  selectedFund: any;
  disableButton: boolean;
  showStickyInvest: boolean;
  investInView: boolean;
  callbackRequested: boolean;
  detailsSlug: string;
  query: string;
  showGraph: boolean;
  selectedTab: string;
  fundRating: number;
  maxFundRating: number;
  isMaxAmountExceed: boolean;
  isMonthlyLimitExceed: boolean;
  totalActiveSIPAmount: number;
  pennyDropInitiated: boolean;
  bankAccountStatus: any;
  userDetails: any;
  bankErrorMsg: string;
  isTimeOut: boolean;
  isBankVerified: boolean;
  pendingActions: any;
  optimizedFund: any;
  scheduleLater: boolean;
  otpScreen: boolean;
  otp: string;
  otpEmail: string;
  otpPhone: string;
  isOtpWrong: boolean;
  isOtpVerified: boolean;
  verifyOtpLoader: boolean;
  investmentToken: string;
  showNomineePopup: boolean;
  showKycModal: boolean;
  kycStatus: any;
  isCheckingKyc: boolean;
  selectedTimePeriod: string;
}
class SingleFundPageNew extends Component<Props, State> {
  private chart: any;
  private modal: any;
  constructor(props: Props) {
    super(props);
    this.initialiseState(this.props, true);
    this.modal = null;
  }
  public callback = () => {
    this.setState({ callbackRequested: true });
    trackAction('request-callback', 'invest-sales', 'fund-page');
    createActivity({
      ActivityEvent: 223,
      ActivityNote: 'Request Callback',
    });
  };

  public initialiseState = (props: Props, initialState: boolean) => {
    const { selectedFund, hasUserInvestedInProduct } = props;
    let minAmount;
    let minSipAmount;
    let defaultItemType;
    let defaultMinAmount;
    let maxAmount;
    let isSIP;
    let suggestedAmount;
    let ratings = {};

    const { amount: queryAmount, investmentType: queryInvestmentType } =
      props.url.query;
    if (selectedFund) {
      minSipAmount = selectedFund.minSipAmount;
      const productId =
        selectedFund.id !== undefined
          ? selectedFund.id
          : selectedFund.productId;
      if (typeof window !== 'undefined' && getIsLoggedInCookie() === 'true') {
        api.getTotalSipAmount(productId).then((response) => {
          const totalActiveSIPAmount = response || 0;
          this.setState({ totalActiveSIPAmount });
        });
      }
      minAmount =
        hasUserInvestedInProduct && selectedFund.minSubsequentAmount
          ? selectedFund.minSubsequentAmount
          : selectedFund.minAmount;
      const maxSipAmount = selectedFund.maxSipAmount;
      const maxLumpsumAmount = selectedFund.maxLumpsumAmount;
      ratings = parseFundRating(selectedFund.morningStarRating);
      const { sipEnabled, lumpSumEnabled } = selectedFund;
      let preferredInvestmentMode;
      if (sipEnabled && !lumpSumEnabled) {
        preferredInvestmentMode = 'SIP_MF';
      } else if (!sipEnabled && lumpSumEnabled) {
        preferredInvestmentMode = 'LUMPSUM_MF';
      }
      defaultItemType = preferredInvestmentMode || Direction.SIP;
      isSIP = (queryInvestmentType || defaultItemType) === Direction.SIP;
      defaultMinAmount = isSIP ? minSipAmount : minAmount;
      maxAmount = isSIP ? maxSipAmount : maxLumpsumAmount;
      suggestedAmount = getSuggestedAmountSafely(
        selectedFund,
        isSIP,
        'minSipAmount',
        'minAmount',
        hasUserInvestedInProduct
      );
    }
    const optimizeFund = optimizeFundData(selectedFund);
    const stateToSet = {
      investmentType: queryInvestmentType || defaultItemType,
      minAmount: defaultMinAmount,
      maxAmount,
      optimizedFund: optimizeFund,
      startFlow: false,
      title: optimizeFund.isNfo
        ? optimizeFund.name
        : optimizeFund.fundLegalName,
      selectedFund: null,
      showStickyInvest: false,
      investInView: false,
      disableButton: false,
      callbackRequested: false,
      detailsSlug: props.url.query.detailsSlug,
      query: props.url.query || {},
      selectedTab: 'summary',
      fundRating: ratings.fundRating,
      maxFundRating: ratings.maxFundRating,
      isMaxAmountExceed: false,
      isMonthlyLimitExceed: false,
      pennyDropInitiated: false,
      bankAccountStatus: '',
      userDetails: {},
      bankErrorMsg: '',
      isTimeOut: false,
      isBankVerified: false,
      pendingActions: props.pendingActions || [],
      scheduleLater: false,
      otpScreen: false,
      otp: '',
      otpEmail: '',
      otpPhone: '',
      isOtpWrong: false,
      isOtpVerified: false,
      verifyOtpLoader: false,
      totalActiveSIPAmount: 0,
      investmentToken: '',
      showNomineePopup: false,
      showKycModal: false,
      kycStatus: null,
      isCheckingKyc: false,
      selectedTimePeriod: '3Y',
    };

    if (initialState) {
      this.state = {
        ...stateToSet,
        amount: queryAmount || suggestedAmount,
        showGraph: false,
      };
    } else {
      this.setState((prevState) => {
        return {
          ...prevState,
          ...stateToSet,
        };
      });
    }
  };

  private scheduleModal = () => {
    this.setState({
      scheduleLater: true,
    });
  };

  private dissmissScheduleModal = () => {
    this.setState({
      scheduleLater: false,
    });
  };

  public handleVariantChange = (e: any) => {
    const { url } = this.props;
    const { fundSlug, amcSlug } = url.query;
    const fundIsin = e.target.value;
    if (fundIsin) {
      Router.pushRoute(`/mutual-funds/${amcSlug}/${fundSlug}/${fundIsin}`);
    }
  };

  public onChange = (e: any) => {
    const { name, value } = e.target;
    const { amount } = this.state;
    const { selectedFund, hasUserInvestedInProduct } = this.props;
    const { minSipAmount, maxSipAmount, maxLumpsumAmount } = selectedFund;
    const minLumpsumAmount =
      hasUserInvestedInProduct && selectedFund.minSubsequentAmount
        ? selectedFund.minSubsequentAmount
        : selectedFund.minAmount;
    let newAmount = amount;
    if (name === 'amount') {
      const regx = /^\d{1,10}$/;
      if (value === '' || regx.test(value)) {
        this.changeState('amount', value);
      } else {
        return;
      }
    } else if (name === 'investmentType') {
      const isSIP = value === Direction.SIP;
      const minAmount = isSIP ? minSipAmount : minLumpsumAmount;
      const maxAmount = isSIP ? maxSipAmount : maxLumpsumAmount;
      const suggestedAmount = getSuggestedAmountSafely(
        selectedFund,
        isSIP,
        'minSipAmount',
        'minAmount',
        hasUserInvestedInProduct
      );
      if (newAmount < parseInt(minAmount.toString().replace(/[,]/g, ''), 10)) {
        newAmount = suggestedAmount;
      }
      const queries = parse(location.search);
      queries.investmentType = value;
      queries.amount = newAmount;
      Router.pushRoute(`${location.pathname}?${stringify(queries)}`, {
        shallow: true,
      });
      this.setState({
        amount: newAmount,
        investmentType: value,
        minAmount: parseInt(minAmount.toString().replace(/[,]/g, ''), 10),
        maxAmount,
      });
    } else {
      this.changeState(name, value);
    }
  };

  public changeState = (key: string, value: any) => {
    this.setState({
      [key]: value,
    });
  };

  public onAmountChangeBlur = (e: any) => {
    const {
      minSipAmount,
      maxSipAmount,
      maxLumpsumAmount,
      lumpsumMultipleAmount,
    } = this.props.selectedFund;
    const { selectedFund, hasUserInvestedInProduct } = this.props;
    const minLumpsumAmount =
      hasUserInvestedInProduct && selectedFund.minSubsequentAmount
        ? selectedFund.minSubsequentAmount
        : selectedFund.minAmount;
    const { investmentType, totalActiveSIPAmount } = this.state;
    const prodId =
      selectedFund.id !== undefined ? selectedFund.id : selectedFund.productId;
    const isSIP = investmentType === Direction.SIP;
    const minAmount = isSIP ? minSipAmount : minLumpsumAmount;
    const maxAmount = isSIP ? maxSipAmount : maxLumpsumAmount;
    let totalAmount;
    // Monthly SIP limit check for Mirae asset emerging bluechip fund
    const allowedSIPAmount = maxAmount - totalActiveSIPAmount;
    const isMaxMonthlyLimitExceed =
      allowedSIPAmount && e.target.value > allowedSIPAmount ? true : false;

    if (isSIP && prodId && prodId === 431 && isMaxMonthlyLimitExceed) {
      // totalAmount = e.target.value;
      this.setState({ isMonthlyLimitExceed: true });
      return;
    } else if (maxAmount && e.target.value > maxAmount) {
      // totalAmount = e.target.value;
      this.setState({ isMaxAmountExceed: true });
      return;
    } else if (minAmount > lumpsumMultipleAmount) {
      totalAmount =
        e.target.value <= minAmount
          ? roundOffToStep(minAmount, lumpsumMultipleAmount)
          : roundOffToStep(e.target.value, lumpsumMultipleAmount);
    } else {
      totalAmount =
        e.target.value <= lumpsumMultipleAmount
          ? roundOffToStep(lumpsumMultipleAmount, lumpsumMultipleAmount)
          : roundOffToStep(e.target.value, lumpsumMultipleAmount);
    }

    const queries = parse(location.search);
    queries.amount = totalAmount;
    this.setState({
      amount: totalAmount,
    });
    Router.pushRoute(`${location.pathname}?${stringify(queries)}`, {
      shallow: true,
    });
  };

  public getSelectedAmt = (amt: any) => {
    this.setState({
      amount: amt,
    });
  };

  public investClick = async (e?: any) => {
    if (e) {
      e.preventDefault();
    }
    const { isMaxAmountExceed, isMonthlyLimitExceed, kycStatus } = this.state;
    if (isMaxAmountExceed || isMonthlyLimitExceed) {
      return;
    }

    // Check if user is logged in
    if (typeof window !== 'undefined' && getIsLoggedInCookie() !== 'true') {
      // User not logged in, proceed with regular flow (will redirect to login)
      return;
    }

    // Check KYC status for logged-in users
    if (!kycStatus) {
      await this.checkKycStatus();
      return;
    }

    // If KYC is verified, proceed with investment
    // Modal is only shown for non-verified or under-process KYC
    this.proceedWithInvestment();
  };

  private checkKycStatus = async () => {
    this.setState({ isCheckingKyc: true });

    try {
      // Fetch NDML KYC details (automatically gets PAN from getUserDetails)
      const ndmlKycResponse = await api.getNdmlKycDetails();

      // NDML API returns data directly, not wrapped in response object
      if (ndmlKycResponse && ndmlKycResponse.kycStatus) {
        const kycStatus = {
          kycStatus: ndmlKycResponse.kycStatus || 'NOT_VERIFIED',
        };

        const KYC_UNDER_REVIEW_STATUSES = [
          'UNDER_PROCESS',
          'DOCS_UPLOADED',
          'PENDING_VERIFICATION',
        ];
        const KYC_INCOMPLETE_STATUSES = [
          'NOT_VERIFIED',
          'DOCS_INCOMPLETE',
          'REJECTED',
          'EXPIRED',
        ];

        // Determine if we should show modal based on KYC status
        const isUnderReview = KYC_UNDER_REVIEW_STATUSES.includes(
          kycStatus.kycStatus
        );
        const isIncomplete = KYC_INCOMPLETE_STATUSES.includes(
          kycStatus.kycStatus
        );
        const shouldShowModal = isUnderReview || isIncomplete;

        this.setState(
          {
            kycStatus,
            showKycModal: shouldShowModal,
            isCheckingKyc: false,
          },
          () => {
            if (!shouldShowModal) {
              this.proceedWithInvestment();
            }
          }
        );
      } else {
        throw new Error('Invalid response from NDML KYC API');
      }
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error('KYC status check error: ', error);
      this.setState({
        showKycModal: true,
        kycStatus: { kycStatus: 'NOT_VERIFIED' },
        isCheckingKyc: false,
      });
    }
  };

  private proceedWithInvestment = () => {
    this.setState({ disableButton: true, showKycModal: false });
    const { amount, investmentType, maxAmount, totalActiveSIPAmount } =
      this.state;
    // check for the mirae asset.. monthly exceed limit
    const allowedSIPAmount = maxAmount - totalActiveSIPAmount;
    const isMaxMonthlyLimitExceed =
      allowedSIPAmount && amount > allowedSIPAmount ? true : false;
    const { id, productId, name, isNfo, purchaseMode, alternateProductId } =
      this.props.selectedFund;
    const prodId = id !== undefined ? id : productId;
    if (prodId && prodId === 431 && isMaxMonthlyLimitExceed) {
      this.setState({ isMonthlyLimitExceed: true });
      return;
    }
    const { query } = this.props.url;
    const { amcSlug, fundSlug, fundIsin } = query;
    trackAction('submit-amount', 'dashboard', name, amount);
    createActivity({
      ActivityEvent: 206,
      ActivityNote: 'Plan Selected',
      Fields: [
        {
          SchemaName: 'mx_Custom_1',
          Value: name,
        },
        {
          SchemaName: 'mx_Custom_2',
          Value: amount,
        },
        {
          SchemaName: 'mx_Custom_3',
          Value: investmentType,
        },
      ],
    });

    let directId = id;
    if (purchaseMode === 'REGULAR') {
      directId = alternateProductId;
    }

    const cart = [
      {
        amount: amount.toString().replace(/,/g, ''),
        itemType: investmentType,
        productId: directId,
        referItem: investmentType === Direction.SIP ? null : {},
      },
    ];
    api.updateCart(cart, 'single-fund', directId).then(() => {
      trackPixel('AddToCart', {
        content_type: 'fund',
        value: directId,
      });
      const { url } = this.props;
      const {
        query: { startPayment },
      } = url;

      if (getUserInfoSessionData()) {
        const routeName = isNfo
          ? 'single-fund-nfo-mutual-funds'
          : 'single-fund-slug-mutual-funds';
        const detailsSlug = startPayment === '1' ? 'payment' : 'first';
        const routeParams = { fundSlug, amcSlug, detailsSlug };
        if (fundIsin) {
          routeParams['fundIsin'] = fundIsin;
        }
        Router.pushRoute(...url.query, routeName, {
          ...url.query,
          ...routeParams,
        });
      } else {
        redirectToLoginPage();
      }
    });
  };

  public visibilityChange = (isInView: boolean) => {
    isInView
      ? this.setState({ showStickyInvest: false, investInView: false })
      : this.setState({ showStickyInvest: true });
  };
  public dismissModal = () => {
    const { query } = this.props.url;
    const { isNfo } = this.props.selectedFund;
    const { amcSlug, fundSlug, fundIsin } = query;
    const { detailsSlug, ...restQueryParams } = query;
    const { planType = 'GROWTH' } = restQueryParams;
    const prefix = isNfo ? '/mutual-funds/nfo/' : '/mutual-funds/';
    if (fundIsin) {
      Router.pushRoute(
        `${prefix}${amcSlug}/${fundSlug}/${fundIsin}?planType=${planType}`,
        restQueryParams
      );
    } else {
      Router.pushRoute(`${prefix}${amcSlug}/${fundSlug}`, restQueryParams);
    }
    this.setState({ disableButton: false });
  };

  public async componentDidMount() {
    // need to run this on browser for navigator dependency
    const { statusCode, url } = this.props;

    if (url.query.startPayment === '1') {
      this.handleStartPaymentFromURL();
    }

    if (!statusCode) {
      api.getCart();
      // const { schemaMaster, returns } = fundData;
      // this.loadStockData(
      //   url.query.fundIsin,
      //   schemaMaster.launchDate,
      //   returns.categoryCode
      // );
    }
  }
  public async componentDidUpdate() {
    const { userInfo } = this.props;
    if (userInfo) {
      const res = await api.getPendingActions();
      if (
        res &&
        JSON.stringify(res.response) !==
          JSON.stringify(this.state.pendingActions)
      ) {
        this.setState({
          pendingActions: res.response,
        });
      }
    }
  }

  public componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  private handleStartPaymentFromURL = async () => {
    this.investClick();
  };

  public UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { detailsSlug: oldDetailsSlug } = this.props.url.query;
    const { detailsSlug } = nextProps.url.query;
    if (detailsSlug !== oldDetailsSlug) {
      this.setState({ detailsSlug });
    }
    this.setState({
      query: nextProps.url.query,
    });

    this.initialiseState(nextProps, false);

    if (nextProps.pendingActions !== this.state.pendingActions) {
      this.setState({
        pendingActions: nextProps.pendingActions,
      });
    }
  }

  public startInvestment = async () => {
    const { selectedFund } = this.props;
    const fundData = await api.getFundDetails(selectedFund.alternateProductId);
    const { slug, parentSlug, isinCode } = fundData.fundMetaData;
    const href = `/mutual-funds/${parentSlug}/${slug}/${isinCode}`;
    Router.pushRoute(href, href, { shallow: true });
  };

  // public getAmountSelection(sipGraphId: string, data: any) {
  //   console.log(data);
  // }

  private onEditFunds = () => {
    this.modal.dismiss();
    this.dismissModal();
  };
  // private isFundDirect(purchaseMode: string) {
  //   return purchaseMode === 'DIRECT' ? true : false;
  // }

  // review rating schema
  private getRatingSchema = () => {
    const { selectedFund } = this.props;
    const {
      fundLegalName,
      latestNav,
      info,
      parentSlug,
      slug,
      isin: isinCode,
      image: imageUrl,
    } = selectedFund;
    let morningStarRating;
    if (info && info.length) {
      morningStarRating = info.filter((ele) => ele.key === 'Morningstar')[0];
    }
    const { dayEndNav } = latestNav || {};
    const issuingAuthority =
      selectedFund && selectedFund.fundMetaData
        ? selectedFund.fundMetaData.issuingAuthority
        : null;
    const expectedRating = [
      '3',
      '3.1',
      '3.2',
      '3.3',
      '3.4',
      '3.5',
      '3.6',
      '3.7',
      '3.8',
      '3.9',
      '4',
    ];
    const randRatingVal =
      expectedRating[Math.floor(Math.random() * expectedRating.length)];
    const ratingValue =
      morningStarRating && morningStarRating.value
        ? morningStarRating.value
        : randRatingVal;
    const author =
      morningStarRating && morningStarRating.value
        ? 'morningStarRating'
        : 'clearTax';
    const schemaObj = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: `${fundLegalName}  - Latest NAV  [ ₹${dayEndNav} ], Returns, Performance, Portfolio &amp; Returns 2021`,
      description: `${fundLegalName} - Latest NAV ₹${dayEndNav}. Detailed analysis &amp; complete track record of  ${fundLegalName}. Get latest updates on, Dividends, Returns, Risks, Portfolio &amp; Exit Load of this Hybrid Fund. Track scheme performance, AUM, historical returns, fund ratings, minimum SIP amount, fund manager etc. at ClearTax`,
      url: `https://cleartax.in/mutual-funds/${parentSlug}/${slug}/${isinCode}`,
      image: `https://assets1.cleartax-cdn.com/clearsave${imageUrl}`,
      brand: {
        '@type': 'Organization',
        name: `${issuingAuthority}`,
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: ratingValue === 'Not Rated' ? '5' : ratingValue,
        bestRating: '5',
        ratingCount: `${randomNumber(70, 140)}`,
      },
      sku: 'NA',
      mpn: 'NA',
      review: {
        '@type': 'Review',
        reviewBody: '',
        author: {
          '@type': 'Organization',
          name: `${author}`,
        },
      },
    };

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schemaObj),
        }}
      />
    );
  };

  public async doPennyDrop(requestObj: any, cb?: any) {
    const { accountNo, ifscCode, cityOfBank, nameOfBank, branchName } =
      requestObj.userBankDetails;
    const bankDetails = {
      accountNo,
      ifscCode,
      cityOfBank,
      nameOfBank,
      branchName,
    };
    let pennyStatusInterval;

    const isTimeoutForPd = setTimeout(() => {
      this.setState({ isTimeOut: true });
      clearInterval(pennyStatusInterval);
    }, 90000);

    const applyPennyDropStatus = () => {
      const { bankAccountStatus } = this.state;
      if (bankAccountStatus.length > 0) {
        clearInterval(pennyStatusInterval);
        clearTimeout(isTimeoutForPd);
      }
      if (bankAccountStatus === 'ACTIVE') {
        setTimeout(() => {
          this.setState(
            { pennyDropInitiated: false, isBankVerified: true },
            () => {
              if (cb) {
                cb(true);
              }
            }
          );
        }, 3000);
      }
    };

    const initPennyResp = await api.initializePennyDrop(bankDetails);

    if (initPennyResp && initPennyResp.success) {
      this.setState(
        {
          pennyDropInitiated: true,
          userDetails: requestObj,
          bankErrorMsg: '',
          bankAccountStatus: '',
        },
        () => {
          pennyStatusInterval = setInterval(async () => {
            const statusResp = await api.getPennyDropStatus(
              accountNo,
              ifscCode
            );
            if (!statusResp.bankAccountStatus) {
              return;
            }
            this.setState(
              {
                bankAccountStatus: statusResp.bankAccountStatus,
              },
              applyPennyDropStatus
            );
          }, 5000);
        }
      );
    } else if (
      initPennyResp &&
      initPennyResp.errorDTO &&
      initPennyResp.errorDTO.message
    ) {
      this.setState({
        bankErrorMsg: initPennyResp.errorDTO.message,
        pennyDropInitiated: false,
      });
    }
  }

  public handleChangeDetails = () => {
    this.setState({
      bankAccountStatus: '',
      pennyDropInitiated: false,
      isTimeOut: false,
    });
  };

  public returnArr = (returnObj: any) => {
    return [
      {
        label: 'Returns per yr (5 year Avg)',
        value: get(returnObj, 'return5Y', ''),
      },
      {
        label: 'Returns per yr (3 year Avg)',
        value: get(returnObj, 'return3Y', ''),
      },
      {
        label: 'Returns per yr (1 year Avg)',
        value: get(returnObj, 'return1Y', ''),
      },
    ];
  };
  public changeDateFormat(date: any) {
    const dateArr = date.split('/');
    const temp = dateArr[0];
    dateArr[0] = dateArr[1];
    dateArr[1] = temp;
    dateArr.join('/');
    const a = new Date(dateArr);
    const newDate = a.toDateString();
    const dateString = newDate.split(' ');
    return dateString;
  }
  public investClicked(clicked: boolean) {
    this.setState({ investInView: clicked });
    if (clicked) {
      this.investClick();
    }
  }

  private handleKycModalDismiss = () => {
    this.setState({
      showKycModal: false,
      disableButton: false,
      kycStatus: null,
    });
  };

  // tslint:disable-next-line:no-unused-variable
  private handleTimePeriodChange = (timePeriod: string) => {
    this.setState({
      selectedTimePeriod: timePeriod,
    });
  };

  private showOtpScreen = async () => {
    this.setState(
      {
        otpScreen: true,
      },
      () => {
        this.generateOtp('NEW_OTP');
      }
    );
  };

  private handleOtpChange = (otp: string) => {
    this.setState({ otp });
  };

  private generateOtp = async (requestType: string) => {
    const { selectedFund } = this.props;
    // const isInstantRedemption =
    //   this.state.redemptionType === INSTANT_REDEMPTION;
    if (selectedFund) {
      try {
        const productIds = [];
        productIds.push(selectedFund.productId);
        const payload = {
          otpRequestType: requestType,
          productIds,
        };
        const res = await api.handleInvestmentOtp(payload, false);
        if (res) {
          if (res.otpStatus === 'OTP_GENERATION_FAILED') {
            showError(res.description);
          } else if (
            res.otpStatus === 'OTP_GENERATED' ||
            res.otpStatus === 'OTP_REGENERATED'
          ) {
            const { email, phone } = res;
            this.setState({
              otpEmail: email,
              otpPhone: phone,
              isOtpWrong: false,
              otp: '',
            });
          }
        }
      } catch (err) {
        showError(err);
      }
    }
  };

  private verifyOtp = async () => {
    const { selectedFund } = this.props;
    const { otp } = this.state;
    if (selectedFund) {
      this.setState({
        verifyOtpLoader: true,
      });
      try {
        const productIds = [];
        productIds.push(selectedFund.productId);
        const payload = {
          otpRequestType: 'VERIFY_OTP',
          productIds,
          otp,
        };
        const res = await api.handleInvestmentOtp(payload, true);
        if (res) {
          if (res.otpStatus === 'VERIFICATION_FAILED') {
            this.setState({
              verifyOtpLoader: false,
            });
            if (res.otpError === 'WRONG_OTP') {
              this.setState({ isOtpWrong: true });
            } else {
              showError(res.otpError);
            }
          } else if (res.otpStatus === 'VERIFICATION_SUCCEED') {
            this.setState({
              otpScreen: false,
              isOtpVerified: true,
              investmentToken: res.investmentToken,
            });
          }
        }
      } catch (err) {
        showError(err);
      }
    }
  };

  public render() {
    // TODO: Cleanup this render, move out code to different rendering blocks
    const {
      amount,
      investmentType,
      detailsSlug,
      pennyDropInitiated,
      bankAccountStatus,
      userDetails,
      bankErrorMsg,
      isTimeOut,
      isBankVerified,
      pendingActions,
      scheduleLater,
      isOtpVerified,
      otp,
      otpEmail,
      otpPhone,
      otpScreen,
      isOtpWrong,
      verifyOtpLoader,
      investmentToken,
      showKycModal,
      kycStatus,
    } = this.state;
    const { userInfo, entity, url } = this.props;
    const isBankPending =
      pendingActions.indexOf('OPS_APPROVAL_PENDING_FOR_BANK_DETAILS') !== -1
        ? true
        : false;

    const isPennyDropPending = pendingActions.includes('PENNY_DROP_NOT_DONE');

    const alreadyInvested = userInfo ? userInfo.alreadyInvested : false;
    const { fundIsin } = url.query;
    const isPaymentMode = detailsSlug === 'payment';
    const modalTitle = 'Complete Your Investment';
    const { fundLegalName, amcDetail, nav, parentSlug, slug } =
      this.state.optimizedFund;
    const title = `${fundLegalName} - Regular  - Latest NAV  [ ₹${nav} ], Returns, Performance, Portfolio & Returns ${presentYear()}`;
    const description = `${fundLegalName} - Latest NAV ₹${nav}. Detailed analysis & complete track record of  ${fundLegalName}. Get latest updates on, Dividends, Returns, Risks, Portfolio & Exit Load of this Hybrid Fund. Track scheme performance, AUM, historical returns, fund ratings, minimum SIP amount, fund manager etc. at ClearTax`;
    const keywords = `mutual funds India, ${fundLegalName}, ${
      amcDetail ? amcDetail.name : ''
    }, Best funds to invest, Best Funds, Mutual Funds, Fund Rating, Fund Returns, Fund Analysis, Equity, Tax`;
    return (
      <div>
        <Fragment>
          <div className="lil-pt-10 sm:lil-py-0">
            {getComponentTree.call(this, this.props.pageData)}
          </div>

          {/* KYC Status Modals */}
          {showKycModal &&
            kycStatus &&
            (() => {
              const KYC_UNDER_REVIEW_STATUSES = [
                'UNDER_PROCESS',
                'DOCS_UPLOADED',
                'PENDING_VERIFICATION',
              ];
              const KYC_INCOMPLETE_STATUSES = [
                'NOT_VERIFIED',
                'DOCS_INCOMPLETE',
                'REJECTED',
                'EXPIRED',
              ];

              const isUnderReview = KYC_UNDER_REVIEW_STATUSES.includes(
                kycStatus.kycStatus
              );
              const isIncomplete = KYC_INCOMPLETE_STATUSES.includes(
                kycStatus.kycStatus
              );

              if (isUnderReview) {
                return (
                  <KycUnderReviewModal onDismiss={this.handleKycModalDismiss} />
                );
              } else if (isIncomplete) {
                return (
                  <KycIncompleteModal onDismiss={this.handleKycModalDismiss} />
                );
              }
              return null;
            })()}

          {detailsSlug ? (
            <div>
              {!isBankPending ? (
                <Modal
                  {...this.props}
                  // maxWidth={isPaymentMode ? '1000px' : ''}
                  subHeadingMessage={
                    pennyDropInitiated
                      ? ''
                      : otpScreen
                      ? 'Verify yourself'
                      : scheduleLater
                      ? 'Schedule order'
                      : getSubHeading(detailsSlug)
                  }
                  title={
                    scheduleLater ? 'Schedule order to pay later' : modalTitle
                  }
                  ref={(modal: any) => (this.modal = modal)}
                  onDismiss={() => this.dismissModal()}
                  handleBack={() => handleBackAction(detailsSlug)}
                  disableBackButton={
                    pennyDropInitiated || otpScreen
                      ? true
                      : disableBackButton(detailsSlug, alreadyInvested)
                  }
                >
                  {pennyDropInitiated ? (
                    <PennyDropView
                      bankAccountStatus={bankAccountStatus}
                      userDetails={userDetails}
                      handleChangeDetails={this.handleChangeDetails}
                      dismissModal={this.dismissModal}
                      isTimeOut={isTimeOut}
                    />
                  ) : otpScreen ? (
                    <OtpModal
                      otp={otp}
                      handleOtpChange={this.handleOtpChange}
                      phone={otpPhone}
                      email={otpEmail}
                      verifyOtp={this.verifyOtp}
                      generateOtp={this.generateOtp}
                      isOtpWrong={isOtpWrong}
                      numOfInputs={6}
                      verifyOtpLoader={verifyOtpLoader}
                    />
                  ) : (
                    <InvestFlowView
                      bankDetails={entity.userBankDetails}
                      personalDetails={entity.userPersonalDetails}
                      hideEdit={alreadyInvested}
                      parentProps={{ ...this.props }}
                      allowedSipDates={get(
                        this.state,
                        'optimizeFundData.allowedSipDates',
                        []
                      )}
                      investmentType={this.state.investmentType}
                      handleEditAmount={this.dismissModal}
                      onEditFunds={this.onEditFunds}
                      hideEditFunds={false}
                      onEdit={this.onEditFunds}
                      isPaymentMode={isPaymentMode}
                      url={this.props.url}
                      handleBack={() => {
                        return handleBackNavigation(detailsSlug);
                      }}
                      doPennyDrop={(bankDetails, cb) =>
                        this.doPennyDrop(bankDetails, cb)
                      }
                      pennyDropPending={isPennyDropPending}
                      bankErrorMsg={bankErrorMsg}
                      isBankVerified={isBankVerified}
                      scheduleLater={scheduleLater}
                      scheduleModal={this.scheduleModal}
                      dissmissScheduleModal={this.dissmissScheduleModal}
                      dismissModal={this.dismissModal}
                      isOtpVerified={isOtpVerified}
                      showOtpScreen={this.showOtpScreen}
                      investmentToken={investmentToken}
                    />
                  )}
                </Modal>
              ) : (
                <Modal
                  title="Documents under review"
                  maxWidth=""
                  disableBackButton={true}
                  onDismiss={this.dismissModal}
                  onUnmount={this.dismissModal}
                >
                  <div className="pl30 pr30">
                    Dear Investor,
                    <br />
                    <br />
                    Your uploaded documents are currently under review. You can
                    start investing as soon as the documents are verified. Our
                    support team will update the status in next 24-48 hours.
                    Thanks for your patience!
                  </div>
                </Modal>
              )}
            </div>
          ) : null}
        </Fragment>
        <MandateFlowView
          investmentType={investmentType}
          amount={amount}
          url={url}
        />
        <Header
          title={title}
          description={description}
          canonicalUrl={`https://cleartax.in/mutual-funds/${parentSlug}/${slug}/${fundIsin}`}
          keywords={keywords}
        />
        {this.getRatingSchema()}
      </div>
    );
  }
}

export default SingleFundPageNew;



// WEBPACK FOOTER //
// ./pages/single-fund-new.tsx